/*  MUI  */
import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { FontSizes, Global } from 'application/Shared/Constants';
import { Notify, Transition } from 'application/Shared/Helpers';
import { Modal, ModalBody, ModalFooter } from 'application/Shared/Modals';
import { WelcomeEmail } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const SendEmail = ({ onClose, successFn, successParam, to }) => {
    const { clientId } = useParams();
    const { t } = useTranslation();
    const session = useSession();
    const theme = useTheme();
    const { tenant } = session;
    const { name } = tenant;

    const WelcomeEmailObject = new WelcomeEmail();

    const sendWelcomeEmail = async () => {
        Notify.i(`Sending email to ${to}`);
        try {
            await WelcomeEmailObject.sendWelcomeEmail({
                clientId,
                emails: [to],
                session,
                t
            });
            Notify.s(t('Users.sentInvitation', { email: to }));
        } catch (err) {
            debug.e(t('Users.sentInvitation.fail'), err.toString());
            Notify.e(t('Users.sentInvitation.fail'));
        }

        if (successFn) {
            await successFn(successParam);
        }
    };

    return (
        <Modal
            open
            aria-labelledby="sendEmailDialog"
            onClick={() => onClose()}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            title={
                <Alert
                    severity="info"
                    icon={false}
                    sx={{ textTransform: 'initial' }}
                >
                    {t('SendEmail.header')}
                </Alert>
            }
        >
            <ModalBody data-testid="sendEmailModalBody">
                <Grid item xs={12}>
                    <span style={{ marginRight: '30px' }}>
                        {t('Common.from')}
                    </span>
                    <Typography
                        variant="span"
                        color="textSecondary"
                        fontWeight={600}
                    >
                        {Global.ASM_EMAIL_NO_REPLY}
                    </Typography>
                    <br />
                    <span style={{ marginRight: '50px' }}>
                        {t('Common.to')}
                    </span>
                    <Typography
                        variant="span"
                        color="textSecondary"
                        fontWeight={600}
                    >
                        {to}
                    </Typography>
                    <hr />
                    <span style={{ marginRight: '15px' }}>
                        {t('Common.subject')}
                    </span>
                    <Typography
                        variant="span"
                        color="textSecondary"
                        fontWeight={600}
                    >
                        {t('Users.invite.emailSubject', { name })}
                    </Typography>
                    <hr />
                    <Box textAlign="center">
                        <Typography
                            sx={{
                                color: 'text.secondary',
                                fontSize: FontSizes[2],
                                fontWeight: 600,
                                marginBottom: '48px'
                            }}
                        >
                            {t('Users.invite.emailIntro')}
                        </Typography>
                        <Typography
                            variant="body2"
                            dangerouslySetInnerHTML={{
                                __html: t('Users.invite.emailBody', {
                                    colorEmail: theme.palette.text.emailAddress,
                                    colorHighlight:
                                        theme.palette.text.secondary,
                                    colorText: theme.palette.text.primary,
                                    email: to
                                })
                            }}
                        />
                        <Typography
                            variant="body2"
                            dangerouslySetInnerHTML={{
                                __html: t('Users.invite.emailContactUs', {
                                    colorEmail: theme.palette.text.emailAddress,
                                    email: session?.user?.email
                                })
                            }}
                            style={{
                                fontSize: FontSizes[0],
                                marginTop: '48px'
                            }}
                        />
                    </Box>
                    <hr />
                </Grid>
            </ModalBody>

            <ModalFooter>
                <Button
                    data-testid="sendEmailBtnCancel"
                    onClick={() => onClose()}
                    variant="outlined"
                    color="primary"
                >
                    {t('Common.cancel')}
                </Button>
                <Button
                    data-testid="sendEmailBtnSend"
                    onClick={() => sendWelcomeEmail()}
                    variant="contained"
                    color="primary"
                >
                    {t('Common.send')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};
